<template>
    <div>
        <user-menu />
        <div class="wrapper">
            <EnterpriseAdminSidebarMenu 
                :readOnly="isReadOnly"
            />
            <div class="content-wrapper">
                <div class="container-wrapper center">
                    <div>
                        <h3 class="d-inline heading">Purchasing</h3>
                    </div>
                    <div class="heading-seperator"></div>
                    <div class="margin-bottom-10"></div>
                    <div class="">
                        <flash-message autoHide variant="success"></flash-message>
                        <b-navbar toggleable="lg" type="light" variant="light">
                            <b-navbar-brand href="#">Filter/Search</b-navbar-brand>
                            <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down	"></i></b-navbar-toggle>
                            <b-collapse id="nav-collapse" is-nav>
                                <div class="search-wrapper col-12">
                                    <div class="row col-12 override-padding">
                                        <div class="search_filter_1"></div>
                                        <div class="search_filter_2">
                                            <button type="button" class="float-left btn btn-sm renewBtn" @click="openRenewModal">Renew Subscription(s)</button>
                                        </div>
                                        <div class="search_filter_3" v-if="!isReadOnly">
                                            <button type="button" class="float-left btn btn-sm createBtn" @click="openNewLocation">Add New Location</button>
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </b-navbar>
                    </div>
                    <div class="margin-bottom-10"></div>

                    
                    <div>
                        <b-card no-body class="manage_locations">
                            <div class="row">
                                <div class="font-weight-bold">Current Subscriptions</div>
                            </div>
                            <div class="list_locations">
                                <div class="row">
                                    <div class="plans-list">
                                        <div class="row">
                                            <div class="subscription_header manage_heading_1">
                                                Account Name
                                            </div>
                                            <div class="subscription_header manage_heading_3 text-center">
                                                Available License
                                            </div>
                                            <div class="subscription_header manage_heading_4 text-center">
                                                # of Licenses Used
                                            </div>
                                            <div class="subscription_header manage_heading_5 text-center">
                                                Total
                                            </div>
                                        </div>
                                        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                                        <div v-if="subscriptions.length > 0" class="row_items">
                                            <div class="row_data_border" v-for="(item, index) in subscriptions" :key="index">
                                                <div class="subscription_item_1">{{ item.accountName }}</div>
                                                <div class="subscription_item_3 text-center">
                                                    {{ item.activeLicense }}
                                                </div>
                                                <div class="subscription_item_4 text-center">
                                                    {{ item.usedLicense }}
                                                </div>
                                                <div class="subscription_item_5 text-center">
                                                    <span class="dollarsign">$</span>{{ numberWithCommas(item.accountTotalAmount) }}
                                                </div>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                        <div v-else class="text-red text-center m-4">No Current Subscriptions Found</div>
                                    </div>
                                    <div class="plans-sumup">
                                        <div class="text-center title"> Total for All Subscriptions </div>
                                        <div class="text-center totalprices">
                                            <span class="dollarsign">$</span>{{ numberWithCommas(plan_total_price) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card>
                    </div>
                    
                    
                    <div class="margin-bottom-10"></div>
                    <div>
                        <b-card no-body class="manage_locations">
                            <div class="row">
                                <div class="psearch_filter_1 font-weight-bold">
                                    Purchase History
                                    <!--a class="print_icons" href="javascript:void(0)" @click="goToPrint">
                                        <i class="fa fa-print"></i>
                                    </a-->
                                </div>
                                <div class="psearch_filter_2">
                                    <b-form-select 
                                        class="location-custom-select" 
                                        v-model="search_purchasing_group" 
                                        :options="account_groups_options"
                                        @change="changeGroups">
                                    </b-form-select>
                                </div>
                                <div class="psearch_filter_3">
                                    <span class="search-icon" @click="setLocationFilterbyName">
                                        <i class="fa fa-search search_icons"></i>
                                    </span>
                                    <input
                                        type="text"
                                        name="org name"
                                        id="search_purchasing_name"
                                        class="search_org_text"
                                        ref="search_purchasing_name"
                                        v-model="search_purchasing_name"
                                        maxlength="250"
                                        @keyup.enter="setLocationFilterbyName">
                                </div>
                            </div>
                            <div class="list_locations">
                                <div class="row">
                                    <div class="subscription_header ph_heading_1">
                                        Date
                                    </div>
                                    <div class="subscription_header ph_heading_2">
                                        Account
                                    </div>
                                    <div class="subscription_header ph_heading_3">
                                        Group
                                    </div>
                                    <div class="subscription_header ph_heading_4">
                                        Unit Type
                                    </div>
                                    <div class="subscription_header ph_heading_6">
                                        Price
                                    </div>
                                    <div class="subscription_header ph_heading_8 text-center">
                                        Receipt
                                    </div>
                                </div>
                                <div v-show="ploading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                                <div v-if="purchasing_history.length > 0" class="row_items">
                                    <div class="row_data_border" v-for="(pitem, pindex) in purchasing_history" :key="pindex">
                                        <div class="ph_item_1">{{ pitem.orderCreatedAt | formatOrderCreatedAt }}</div>
                                        <div class="ph_item_2">{{ pitem.accountName }}</div>
                                        <div class="ph_item_3">{{ pitem.groupName ? pitem.groupName : 'n/a' }}</div>
                                        <div class="ph_item_4">{{ pitem.subscriptionName }}</div>
                                        <div class="ph_item_6">
                                            <span class="dollarsign">$</span>{{ pitem.price }}
                                        </div>
                                        <div class="ph_item_8 text-center">
                                            <a href="javascript:void(0);" class="invoice_link" @click="getInvoicePdf(pitem)">
                                            <img src="@/assets/enterprise/Resources_16x16.png" />
                                            </a>
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                <div v-else class="text-red text-center m-4">No Purchase History Found</div>
                            </div>
                        </b-card>
                    </div>
                </div>
            </div>
        </div>

        <AddNewLocation v-if="!isReadOnly"
            :isModalLocationVisible="isModalLocationVisible" 
            :accountId="accountId"
            @close="closeAddNewLocation"
            ref="add_new_location" 
            />

        <EnterpriseAdminRenewSubscription
              :isEnterpriseAdminRenewSubscriptionModalVisible="isEnterpriseAdminRenewSubscriptionModalVisible" 
              :accountId="accountId"
              @close="closeEnterpriseAdminRenewSubscription"
              ref="enterprise_admin_renew_subscription_modal" 
             />

    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import AddNewLocation from './add_new_location.vue';
import router from '../../router/index.js';
import { store } from '../../store/store';
import moment from 'moment';
import EnterpriseAdminRenewSubscription from './enterpriseadmin_renew_subscription.vue';

Vue.filter('formatOrderCreatedAt', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

Vue.filter('formatOrderExpired', function(value) {
  if (value != 'n/a') {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
  else {
    return 'n/a';
  }
});

export default {
    data() {
        return {
            loading: false,
            ploading: false,
            isModalRenewVisible: false,
            isModalLocationVisible: false,
            plan_total_price: 0,
            subscriptions: [],
            purchasing_history: [],
            accountItems: [],
            account_groups_options: [],
            accountId: '',
            search_purchasing_group: '',
            search_purchasing_group_name: '',
            search_purchasing_name: '',
            selectedText: '',
            isEnterpriseAdminRenewSubscriptionModalVisible: false,
        }
    },
    components: {
        UserMenu,
        EnterpriseAdminSidebarMenu,
        AddNewLocation,
        EnterpriseAdminRenewSubscription,
    },
    computed: {
        isReadOnly(){
            if (this.$store.state.enterprise_type === 'Readonly') {
                return true;
            } else {
                if (this.$store.state.switch_admin_enterprise_isreadonly) {
                    return true;
                } else {
                    return false;
                }
            }
        },
    },
    methods: {
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        getEnterpriseGroups() {
            if (this.accountId > 0) {
                axios('/enterprise-admin/groups/' + this.accountId,
                {
                    method: 'GET',
                })
                .then(response => {
                    var groupsCount = response.data.groups.length;
                    this.account_groups_options.push({ text:'Groups', value: '' });
                    for (var m = 0; m < groupsCount; m++) {
                        this.account_groups_options.push({ 
                            text: response.data.groups[m].text, 
                            value: response.data.groups[m].value 
                        });
                    }
                })
                .catch(() => {
                });
            }
        },
        fetchSubscriptions() {
            this.loading = true;
            axios('/enterprise-admin/subscriptionlists',
            {
                method: 'GET',
            })
            .then(response => {
                this.loading = false;
                this.subscriptions = response.data.subscriptions;
                this.plan_total_price = response.data.plan_total_price;
            })
            .catch(() => {
            });
        },
        fetchPurchaseHistory() {
            this.ploading = true;
            var params = {};
            if (this.search_purchasing_group) {
                params.search_purchasing_group = this.search_purchasing_group; 
            }
            if (this.search_purchasing_name) {
                params.search_purchasing_name = this.search_purchasing_name; 
            }
            if (this.search_purchasing_group_name) {
                params.search_purchasing_group_name = this.search_purchasing_group_name;
            }
            if (params.search_purchasing_group || params.search_purchasing_name) {
                this.$store.dispatch('search_enterprise_purchasing_history', params);
            }
            axios('/enterprise-admin/purchase-history',
            {
                method: 'POST',
                data: {
                    search_params: params,
                }
            })
            .then(response => {
                this.ploading = false;
                this.purchasing_history = response.data.purchasing_history;
            })
            .catch(() => {
            });
        },
        showText(val) {
            for (var i = 0; i < this.account_groups_options.length; i++) {
                if (this.account_groups_options[i].value != "" && this.account_groups_options[i].value === val){
                    this.selectedText = this.account_groups_options[i].text;
                    return this.selectedText.charAt(0).toUpperCase() + this.selectedText.slice(1);
                }
            }
            return '';
        },
        changeGroups() {
            if (this.search_purchasing_group) {
                var name = this.showText(this.search_purchasing_group);
                this.search_purchasing_group_name = name + ' Locations';
            }
            this.fetchPurchaseHistory();
        },
        setLocationFilterbyName() {
            this.fetchPurchaseHistory();
        },
        getInvoicePdf(item) {
          axios('/getOrderInvoicePdf',
            {
              method: 'POST',
              data: {
                  "billing": {
                      "billing_name": item.billingName,
                      "billing_address": item.address,
                      "billing_address2": item.address2,
                      "billing_city": item.city,
                      "billing_country": item.countryCode,
                      "billing_phone": item.phoneNumber,
                      "billing_state": item.stateCode,
                      "billing_zip": item.zipCode,
                      "billing_primary_admin": item.billing_primary_admin
                  },
                  "orderId": item.orderId
              }
            },
          )
          .then(response => {
            window.open(response.data.invoice_filepath, '_blank');
          })
          .catch(error => {
            console.log(error)
          });
        },
        goToPrint(){
            router.push('/print-enterprise-purchasing')
        },
        openNewLocation() {
            this.isModalLocationVisible = true;
            this.accountId = this.accountId;
            this.$refs.add_new_location.page_from_purchasing = true;
            this.$refs.add_new_location.loadInitialData();
        },
        closeAddNewLocation() {
            this.isModalLocationVisible = false;
        },
        openRenewModal() {
            this.isEnterpriseAdminRenewSubscriptionModalVisible = true;
            this.accountId = this.accountId;
            this.$refs.enterprise_admin_renew_subscription_modal.loadInitialData();
        },
        closeEnterpriseAdminRenewSubscription() {
            this.isEnterpriseAdminRenewSubscriptionModalVisible = false;
        }
    },
    created() {
        store.dispatch('clear_search_enterprise_purchasing_history');
        axios('/enterprise-admin-info',
        {
            method: 'GET',
        })
        .then(resp => {
            this.accountItems = resp.data.account;
            this.accountId = this.accountItems.id;
            this.locationListTitle = this.defaultTitle;
            this.fetchSubscriptions();
            this.fetchPurchaseHistory();
            this.getEnterpriseGroups();
        })
        .catch(() => {
        });
        
    },
}
</script>
<style scoped>
.manage_locations { padding: 1.5rem; background-color: #FFF !important; }
.list_locations { padding: 0 1rem; margin: 1rem 0; }
.subscription_header { float: left; font-weight: 900; margin-top: 15px; text-decoration: underline; }
.plans-list { width: 80%; border-right: 1px solid #ccc; padding: 0 20px; }
.plans-sumup { width: 20%; }
.plans-sumup .title{ text-decoration: underline; color: #00acee; font-weight: 900; margin: 1rem 0; }
.plans-sumup .totalprices { text-decoration: none; color: #00acee; font-weight: 900; margin: 1rem 0; }
.text-blue { color: #00acee !important; }
.manage_heading_1 { width: 33%; cursor: pointer; }
.manage_heading_2 { width: 20%; cursor: pointer; }
.manage_heading_3 { width: 25%; cursor: pointer; }
.manage_heading_4 { width: 25%; cursor: pointer; }
.manage_heading_5 { width: 17%; cursor: pointer; }
.manage_heading_6 { width: 20%; cursor: pointer; }
.subscription_item_1 { width: 33%; float: left; }
.subscription_item_2 { width: 20%; float: left; }
.subscription_item_3 { width: 25%; float: left; }
.subscription_item_4 { width: 25%; float: left; }
.subscription_item_5 { width: 17%; float: left; }
.subscription_item_6 { width: 20%; float: left; }
.ph_heading_1 { width: 15%; cursor: pointer; }
.ph_heading_2 { width: 30%; cursor: pointer; }
.ph_heading_3 { width: 15%; cursor: pointer; }
.ph_heading_4 { width: 15%; cursor: pointer; }
.ph_heading_5 { width: 15%; cursor: pointer; }
.ph_heading_6 { width: 15%; cursor: pointer; }
.ph_heading_7 { width: 15%; cursor: pointer; text-align: center; }
.ph_heading_8 { width: 10%; cursor: pointer; text-align: center; }
.ph_item_1 { width: 15%; float: left; }
.ph_item_2 { width: 30%; float: left; }
.ph_item_3 { width: 15%; float: left; }
.ph_item_4 { width: 15%; float: left; }
.ph_item_5 { width: 15%; float: left; }
.ph_item_6 { width: 15%; float: left; }
.ph_item_7 { width: 15%; float: left; text-align: center; background-color: #a1ee92; border-radius: 5px; }
.ph_item_8 { width: 10%; float: left; text-align: center; }
.search_filter_1 { width: 48%; }
.search_filter_2 { width: 25%; margin-right: 10px; }
.search_filter_3 { width: 25%; }
.psearch_filter_1 { width: 50%; }
.psearch_filter_2 { width: 25%; }
.psearch_filter_3 { width: 25%; }
.row_items { margin-right: -15px; margin-left: -15px }
.row_data_border { padding: 5px 0; margin: 10px 0; font-size: 14px; }
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.heading { padding-left: 0px; }
.print_icons { font-size: 1.5rem; padding-left: 25px; color: #000 !important; }
.search_icons { font-size: 1.5rem; color: #bfbfbf; }
.location-custom-select { width: 150px; height: 32px; }
.search_org_text { width: 120px;outline: 0; border-width: 0 0 2px; border-color: #bfbfbf;  }
.createBtn, .createBtn:focus, .createBtn:active, .createBtn:hover {
  color: #FFF !important; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 100%;
  border-radius: 10px;
}
.renewBtn, .renewBtn:focus, .renewBtn:active, .renewBtn:hover {
  color: #00acee !important; 
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 100%;
  border-radius: 10px;
}.loading_show { height: auto; }
.linkable { text-decoration: underline; color: #000 !important; cursor: none; }
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/purchasing.vue